import { ComponentProps, FC } from 'react'
import NiceModal from '@ebay/nice-modal-react'
import { useModalManager } from './modalManager'
import { ModalResolveType } from './utils'

export * from './utils'
export { ModalManagerProvider } from './modalManager'

export function createModal<C extends FC<any>>(modal: C): FC<ComponentProps<C>> {
  return NiceModal.create(modal);
}

export function useModalAction() {
  const { resolve, resolveHide, ...resetProps } = NiceModal.useModal();

  return {
    ...resetProps,
    reject: (error: unknown, data?: unknown) =>
      resolve({
        type: ModalResolveType.ERROR,
        error,
        data,
      }),
    resolve: (type: ModalResolveType, data?: unknown) => resolve({ type, data }),
    resolveHide: (type: ModalResolveType, data?: unknown) => resolveHide({ type, data }),
  };
}

export function useModal() {
  const { showModal, removeAllModals } = useModalManager();

  return { showModal, removeAllModals };
}
